import type { GridApi } from "ag-grid-community";

export type TopSheetStructureEditTarget = {
  kind: "category" | "subcategory";
  id: number;
};

export const TOP_SHEET_DESCRIPTION_COL_ID = "description";

export function focusTopSheetStructureRename(
  api: GridApi,
  target: TopSheetStructureEditTarget,
  isCategoryRow: (data: unknown) => boolean,
  isSubCategoryRow: (data: unknown) => boolean
): boolean {
  if (typeof api.isDestroyed === "function" && api.isDestroyed()) return false;

  let focused = false;

  api.forEachNode((node) => {
    if (focused || node.rowIndex == null || !node.data) return;

    const matchesCategory =
      target.kind === "category" &&
      isCategoryRow(node.data) &&
      (node.data as { budget_category_id: number }).budget_category_id === target.id;

    const matchesSubCategory =
      target.kind === "subcategory" &&
      isSubCategoryRow(node.data) &&
      (node.data as { budget_sub_category_id: number }).budget_sub_category_id === target.id;

    if (!matchesCategory && !matchesSubCategory) return;

    api.ensureIndexVisible(node.rowIndex);
    api.setFocusedCell(node.rowIndex, TOP_SHEET_DESCRIPTION_COL_ID);
    api.startEditingCell({
      rowIndex: node.rowIndex,
      colKey: TOP_SHEET_DESCRIPTION_COL_ID,
    });
    focused = true;
  });

  return focused;
}
